"use client"
import { motion } from "framer-motion"
import { RotateCw, Pause } from "lucide-react"

interface FloatingAutoRotateButtonProps {
  autoRotate: boolean
  toggleAutoRotate: () => void
}

export default function FloatingAutoRotateButton({ autoRotate, toggleAutoRotate }: FloatingAutoRotateButtonProps) {
  return (
    <motion.div className="fixed bottom-6 left-6 z-50" whileTap={{ scale: 0.95 }} whileHover={{ scale: 1.1 }}>
      <button
        onClick={toggleAutoRotate}
        className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-lg hover:bg-gray-100 transition-colors"
        aria-label={autoRotate ? "Pause Rotation" : "Start Rotation"}
      >
        {autoRotate ? <RotateCw size={24} className="text-[#6c9956] animate-spin duration-5000" /> : <Pause size={24} className="text-red-400" />}
        <span className="sr-only">Auto-Rotate: {autoRotate ? "On" : "Off"}</span>
      </button>
    </motion.div>
  )
}

